'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDev = void 0;
const $ = require("jquery");
class FormDev {
    constructor() {
        const vals = {
            'text': {
                'your-name': '佐藤元',
                'your-birthday': '1952/12/31',
                'your-address': '東京都千代田区千代田1-1',
                'your-telno': '079-443-5577',
            },
            'email': {
                'your-email': 'debug@nic-lab.jp',
            },
            'textarea': {
                'gakureki': '東京中学校卒業',
            },
        };
        $('#trigFormDevTool').on('click', () => {
            Object.keys(vals.text).forEach((k) => {
                $('input[name="' + k + '"]').val(vals.text[k]);
            });
            Object.keys(vals.email).forEach((k) => {
                $('input[name="' + k + '"]').val(vals.email[k]);
            });
            Object.keys(vals.textarea).forEach((k) => {
                let val = vals.textarea[k] + "\n" + vals.textarea[k] + "\n\n" + vals.textarea[k];
                // val += "<script>alert('hoge');</script>";
                $('textarea[name="' + k + '"]').val(val);
            });
        });
    }
}
exports.FormDev = FormDev;
exports.default = FormDev;
